import {ASSET_TYPES} from './constants';

/**
 * @deprecated Use `checkIsAsset` from `types/content/utils` instead
 *
 * Is Basic Asset
 * @param {object} asset - Asset object
 * @returns {boolean} Matches or not
 */

export default function isBasicAsset(asset) {
	if (!asset) {
		return false;
	}

	return ASSET_TYPES.includes(asset.type);
}
